import { ActionTree } from 'vuex';
import axios from 'axios';
import { RootState } from '@/store/types';
import {ProxySettingFilter, ProxySettingItem, ProxySettingsState} from './types';

export const actions: ActionTree<ProxySettingsState, RootState> = {
  getProxySettings: ({commit, dispatch}, data: ProxySettingFilter) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({url: '/acapi/settings/proxy', params: data})
        .then(resp => {
          if (data?.page_number > 1) {
            commit('pushProxySettings', resp.data?.proxy_settings);
          } else {
            commit('setProxySettings', resp.data?.proxy_settings);
            resolve(resp);
          }
          resolve(resp.data?.proxy_settings)
        })
        .catch(err => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
      })
  },
  getProxySettingItem: ({commit, dispatch},id) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({url: `/acapi/settings/proxy/${id}`})
        .then((resp:any) => {
          let proxySettingItem = <ProxySettingItem>resp.data;
          proxySettingItem.id = id;
          commit('setProxySettingItem', proxySettingItem);
          resolve(proxySettingItem)
        })
        .catch(err => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
      })
  },
  saveProxySettings: ({commit, dispatch}, data: ProxySettingItem) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
          method: data.id ? 'put' : 'post',
          url: '/acapi/settings/proxy/' + (data.id ?? ''),
          data: data
      })
        .then((resp:any) => {
          dispatch('getProxySettings');
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
      })
  },
  deleteProxySetting: ({commit, dispatch}, data: ProxySettingItem) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
          method: 'delete',
          url: `/acapi/settings/proxy/${data.id}`,
          data: data
      })
        .then((resp:any) => {
          dispatch('getProxySettings');
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
      })
  }
};
